export default "__VITE_ASSET__3kYs3VJF__"